var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1182",
    "data-name": "Ret\\xE2ngulo 1182",
    width: 60,
    height: 60,
    rx: 10,
    fill: "#fff595",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Call",
    "data-name": "Iconly Two-tone Call",
    transform: "translate(13.718 13.717)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-126",
    "data-name": "Stroke 1-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316",
    "data-name": "Caminho 316",
    d: "M960.884,406.873c-4.063,0-9.361-3.238-15.746-9.622-6.411-6.408-9.649-11.723-9.626-15.793a6.076,6.076,0,0,1,1.955-4.585c.028-.034.12-.127.153-.158,2.34-2.341,3.871-3.307,5.485-3.268,1.821.023,3.117,1.388,4.76,3.116.406.427.845.89,1.334,1.379,2.381,2.381,1.7,4.319,1.158,5.88-.592,1.7-1.106,3.168,1.968,6.242s4.541,2.562,6.242,1.963c1.559-.545,3.5-1.226,5.881,1.154.483.483.939.918,1.362,1.319,1.735,1.652,3.106,2.953,3.129,4.781.018,1.556-.926,3.142-3.261,5.478l-1.034-.7.874.856a6.078,6.078,0,0,1-4.585,1.957Zm-21.527-28.436s-.078.085-.181.186a3.682,3.682,0,0,0-1.218,2.848c-.013,2.333,1.521,6.665,8.911,14.052,7.35,7.35,11.676,8.9,14.016,8.9l.033,0a3.687,3.687,0,0,0,2.85-1.22,3.449,3.449,0,0,1,.279-.264c1.622-1.634,2.456-2.85,2.446-3.631s-1-1.735-2.367-3.038c-.437-.414-.908-.863-1.407-1.362-1.294-1.291-1.934-1.066-3.343-.576-1.948.685-4.617,1.619-8.778-2.542s-3.228-6.829-2.549-8.779c.492-1.407.718-2.05-.577-3.344-.505-.5-.959-.982-1.378-1.423-1.293-1.361-2.227-2.345-3.02-2.354h-.011c-.783,0-2,.835-3.713,2.55Z",
    transform: "translate(-935.512 -373.446)",
    fill: "#fff595"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-102",
    "data-name": "Stroke 3-102",
    transform: "translate(19.325 5.777)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317",
    "data-name": "Caminho 317",
    d: "M954.292,385.143a1.223,1.223,0,0,1-1.2-.99,5.971,5.971,0,0,0-4.74-4.74,1.223,1.223,0,0,1,.468-2.4,8.412,8.412,0,0,1,6.674,6.674,1.224,1.224,0,0,1-.967,1.435A1.311,1.311,0,0,1,954.292,385.143Z",
    transform: "translate(-947.364 -376.989)",
    fill: "#fff595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.70e860e4714110c4c38476be95269c39.svg";
export { ForwardRef as ReactComponent };